import { render } from "./ControleCobrancasImobiliariasView.vue?vue&type=template&id=710533fb&scoped=true"
import script from "./ControleCobrancasImobiliariasView.vue?vue&type=script&lang=js"
export * from "./ControleCobrancasImobiliariasView.vue?vue&type=script&lang=js"

import "./ControleCobrancasImobiliariasView.vue?vue&type=style&index=0&id=710533fb&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710533fb"]])

export default __exports__